// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ycc1","notes":"Notes_notes__1cmmi","note":"Notes_note__3swug","markdown":"Notes_markdown__3KGX_"};